// extracted by mini-css-extract-plugin
module.exports = {"container":"SubscriptionTerms_container__35GSn","title":"SubscriptionTerms_title__18Edl","list":"SubscriptionTerms_list__1ypf7"};